import axios from 'axios';
import PmsUrlConfig from '../urlConfig.js';

export const fetchSystemConstants = async (token) => {
    
    const url = PmsUrlConfig.BOS_FETCH_SYSTEM_CONSTANTS_URL
    
    try {
        console.log('Fetching system constants from:', url);
        
        const response = await axios.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        console.log('System constants fetched successfully, status:', response.status);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch system constants:', error.message);
        throw error;
    }
};
